import React from 'react';
import Swiper from 'react-id-swiper';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import CONSTANTS_COMMENTS from './Constants';

import * as styles from './TabSellingProperties.scss';

const SliderComments = (props) => {
    const translate = props.translate('internationalExposure', 'sliderComments');
    const params = {
        slidesPerView: 1.8,
        spaceBetween: 10,
        pagination: { clickable: true },
        rebuildOnUpdate: true,
        breakpoints: {
            1580: {
                slidesPerView: 1.5
            },
            800: {
                slidesPerView: 1.2
            }
        }
    };

    const mappedItems = (item) => (
        <div className={styles.sliderWrapper}>
            <div className={styles.slider}>
            <img src={item.photo} className={styles.sliderPhoto} alt="realtor" />
                <div className={styles.infoSlider}>
                    <p>{translate(item.region, 'name')}</p>
                    <img src={item.flag} alt="realtor" />
                </div>
                <div className={styles.sliderComment}>
                    <p>
                        {translate(item.region, 'comment')}
                    </p>
                    <p>
                        {translate(item.region, 'link')}
                    </p>
                </div>
            </div>
        </div>
    );

    return (
      <div className={styles.containerSlider}>
          <Swiper
            {...params}
          >
            {CONSTANTS_COMMENTS.map(mappedItems)}
          </Swiper>
      </div>
    );
};

SliderComments.propTypes = {
    translate: PropTypes.func
};

const mapStateToProps = state => ({
    translate: getLang(state.lang, 'RealtorLanding', 'NavTabs')
});

export default connect(mapStateToProps)(SliderComments);
